






















































































































import Vue, { PropType } from "vue";
import { FieldDataTransitionsContent } from "@/features/coreWebVitals/types";
import DailyFieldDataChart from "@/features/coreWebVitals/components/dailyFieldDataChart.vue";
// TODO: features → commons に移動
import NoData from "@/features/home/components/noData.vue";

export default Vue.extend({
  components: {
    "daily-field-data-chart": DailyFieldDataChart,
    "no-data": NoData,
  },

  props: {
    fieldDataTransitions: {
      type: Object as PropType<{
        fcp: FieldDataTransitionsContent;
        lcp: FieldDataTransitionsContent;
        cls: FieldDataTransitionsContent;
        fid: FieldDataTransitionsContent;
      }>,
      required: true,
    },
    periodInput: { type: Number, required: true },
    periodItems: { type: Array as PropType<number[]>, required: true },
    isNoSelectDomain: { type: Boolean, required: true },
    isNullInFieldDataTransitions: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
  },

  computed: {
    childPeriodInput: {
      get(this: any): number {
        return this.periodInput;
      },
      set(val: number) {
        return this.$emit("update:periodInput", val);
      },
    },
  },

  methods: {
    isNoLcpData() {
      if (!this.fieldDataTransitions.lcp) return true;
      return this.fieldDataTransitions.lcp.score.every(value => value === null);
    },
    isNoClsData() {
      if (!this.fieldDataTransitions.cls) return true;
      return this.fieldDataTransitions.cls.score.every(value => value === null);
    },
    isNoFidData() {
      if (!this.fieldDataTransitions.fid) return true;
      return this.fieldDataTransitions.fid.score.every(value => value === null);
    },
    isNoFcpData() {
      if (!this.fieldDataTransitions.fcp) return true;
      return this.fieldDataTransitions.fcp.score.every(value => value === null);
    },
  },
});
